export const NATIVE_EVENT_NAME = "nativeEvent";

export const AUDIO_PLAY_MESSAGE_TYPE = "AUDIO_PLAY";
export const AUDIO_PAUSE_MESSAGE_TYPE = "AUDIO_PAUSE";
export const VIDEO_PLAY_MESSAGE_TYPE = "VIDEO_PLAY";

export type NativeAudioMessageType = typeof AUDIO_PLAY_MESSAGE_TYPE | typeof AUDIO_PAUSE_MESSAGE_TYPE;
export type NativeVideoMessageType = typeof VIDEO_PLAY_MESSAGE_TYPE;
export type NativeMessageType = NativeAudioMessageType | NativeVideoMessageType;
